'use strict';

import logger from 'loglevel';
import config from '../../js/config';

const log = logger.getLogger('VideoDesk');

export default class VideoDeskBaseController {
  constructor(initializationSettings) {
    this.initializeSettings(initializationSettings);
    this.loadVideoDeskScript();
  }

  initializeSettings(additionalSettings = {}) {
    this.vd = window._videodesk = window._videodesk || {
      firstname: '',
      lastname: '',
      email: '',
      phone: '',
      customer_lang: '',
      customer_id: '',
      customer_url: '',
      cart_id: '',
      cart_url: '',
      order_id: '',
      order_url: '',
      lang: 'en',
      custom_fields: {},
      uid: config.videoDesk.uid,                          // arrow_dev website on videodesk preprod
      module_url: config.videoDesk.moduleUrl,             // cache server
      pusher_auth_url: config.videoDesk.pusherAuthUrl,    // Pusher authentications
      debug: 1,
      debug_url: config.videoDesk.debugUrl,               // New Relic
      module_front_url: config.videoDesk.moduleFrontUrl,  // assets / css etc
      bo_url: config.videoDesk.boUrl,                     // Back office
      audio_reborn_url: config.videoDesk.audioRebornUrl,
      log_url: config.videoDesk.logUrl,
      ...additionalSettings
    };
  }

  loadVideoDeskScript() {
    log.debug('VideoDesk: inserting script tag');
    let scr = document.createElement('script');
    scr.type = 'text/javascript';
    scr.async = true;
    scr.src = (document.location.protocol === 'https:' ? 'https://' : 'http://') + config.videoDesk.libUrl;
    let s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(scr, s);
  }
}



// WEBPACK FOOTER //
// ./assets/components/VideoDesk/VideoDeskBaseController.js